import { Action } from './action'
import { Actions } from './actions'

interface VonageAgentIdModel {
    agentId: string;
}
  
const initial: VonageAgentIdModel = {
    agentId: '',
};

export const vonageAgentId = (context: any) => {
    const { log } = context;
    return (state: VonageAgentIdModel = initial, action: Action<Actions>) => {
        let updated = state;
        const { type, payload } = action;
        switch (type) {
            case Actions.SETAGENTID:
                updated = {
                    agentId: payload,
                };
                break;

            case Actions.RESETAGENTID:
                updated = initial;
                break;
        }
        return updated;
    }
}
